import { Button, Dialog, DialogActions, DialogContent, Theme } from '@mui/material';
import { Check, Close } from 'mdi-material-ui';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { compose } from 'recompose';

import DialogHeader from '@/components/dialogs/dialog-header';
import { WithStyles, withStyles } from '@/hocs/with-styles';
import { WithWidth, isWidthUp, withWidth } from '@/hocs/with-width';

const styles = (theme: Theme) => ({
  topPadding: {
    paddingTop: theme.spacing(3),
  },
  titlebar: {
    backgroundColor: '#f7f7f7',
  },
  actions: {
    justifyContent: 'right',
  },
});

interface Properties {
  open: boolean;
  title?: string | JSX.Element;
  content?: string | JSX.Element;
  onConfirm?: () => void;
  onClose?: () => void;
  actions?: null | JSX.Element;
}

interface State {}

class ConfirmDialog extends React.Component<
  Properties & WithWidth & WithTranslation & WithStyles<typeof styles>,
  State
> {
  readonly state: State = {};

  public render() {
    const { classes, fullScreen, onClose, onConfirm, open, t, theme, width, actions: requestedActions } = this.props;
    const title = this.props.title || '';
    const content = this.props.content || '';
    const actions = requestedActions
      ? () => requestedActions
      : () => (
          <>
            <Button color="primary" onClick={onClose}>
              <Close style={{ marginRight: theme.spacing(), marginTop: '-3px' }} />
              {isWidthUp('md', width) ? t(['shared:close'], { defaultValue: 'Close' }) : ''}
            </Button>
            <Button color="primary" onClick={onConfirm}>
              <Check style={{ marginRight: theme.spacing(), marginTop: '-3px' }} />
              {isWidthUp('md', width) ? t(['shared:confirm'], { defaultValue: 'Confirm' }) : ''}
            </Button>
          </>
        );

    return (
      <Dialog fullScreen={fullScreen} open={open} onClose={onClose} fullWidth maxWidth="sm" scroll="body">
        <DialogHeader title={title} onClose={onClose} />
        <DialogContent className={classes.topPadding}>{content}</DialogContent>
        <DialogActions className={classes.actions}>{actions()}</DialogActions>
      </Dialog>
    );
  }
}

const enhance = compose<unknown, Properties>(
  withWidth(),
  withTranslation(['shared']),
  withStyles(styles, { withTheme: true }),
);

export default enhance(ConfirmDialog as React.ComponentType<unknown>);
